import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const before = ['Llegás a cada consulta sin una estructura clara de qué revisar primero', 'Preparás planes, explicaciones y seguimientos desde cero cada vez', 'Tu material clínico está disperso entre PDFs, notas, carpetas y archivos sueltos', 'Repetís las mismas explicaciones una y otra vez sin un recurso de apoyo', 'Los controles se sienten improvisados y sin criterio clínico definido', 'Sabés que tu consultorio podría verse más organizado y profesional', 'Terminás el día con más trabajo pendiente del que empezaste'];
const after = ['Entrás a cada consulta con estructura clara, criterio clínico y seguridad', 'Armás planes personalizados en menos de 5 minutos sin empezar de cero', 'Todo tu sistema de consulta está en un solo lugar, organizado y listo', 'Explicás con guías visuales claras que el paciente realmente entiende', 'Hacés seguimientos con indicadores clínicos reales más allá del peso', 'Tu práctica se ve y se siente premium, organizada y de autoridad', 'Cerrás el día con consultas bien resueltas y próximos pasos definidos'];
export function PainSection() {
  return <section className="w-full bg-off-white px-5 py-12 sm:py-20" data-id="element-137" data-mp="5fsqmo4p0xds">
      <div className="mx-auto max-w-5xl" data-id="element-138" data-mp="5f17wdw72u4x">
        <div className="mx-auto max-w-2xl text-center" data-id="element-139" data-mp="gzh16sj1qiw">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-slate sm:text-4xl" data-id="element-140" data-mp="hiuobb59sr4">
            ¿Te identificás con alguna de estas situaciones?
          </h2>
          <p className="mt-3 text-sm italic text-dark-green sm:text-base" data-id="element-141" data-mp="33yrakpmbaij7">
            Si respondiste sí a una sola, este sistema fue creado para vos.
          </p>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-142" data-mp="3dvcgdd65nxo3">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5
        }} className="rounded-2xl border-l-4 border-red-300 bg-[#FFF5F5] p-6 sm:p-8" data-id="element-143" data-mp="3dtt0vosbpqnd">
            <h3 className="mb-5 text-lg font-bold text-slate sm:text-xl" data-id="element-144" data-mp="u23nnwtbxtq8">Sin el sistema</h3>
            <ul className="space-y-3" data-id="element-145" data-mp="yt3o3c1nqtxh">
              {before.map(item => <li key={item} className="flex items-start gap-3" data-id="element-146" data-mp="yvq1hsb8c3nm">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-500" data-id="element-147" data-mp="12txc05f3o8qd">
                    <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-148" data-mp="67arjk6ygbj5" />
                  </span>
                  <span className="text-sm leading-relaxed text-slate/80" data-id="element-149" data-mp="b659yl10fy2q">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="rounded-2xl border-l-4 border-sage bg-[#F0F7ED] p-6 sm:p-8" data-id="element-150" data-mp="k4zb8opadcmm">
            <h3 className="mb-5 text-lg font-bold text-dark-green sm:text-xl" data-id="element-151" data-mp="25pnluxbyh0rj">
              Con Sistema Nutri-Pro Completo™
            </h3>
            <ul className="space-y-3" data-id="element-152" data-mp="1vx81xuh3m240">
              {after.map(item => <li key={item} className="flex items-start gap-3" data-id="element-153" data-mp="1vvna4cm64x9u">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage/20 text-dark-green" data-id="element-154" data-mp="1rvwmghrxux9j">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-155" data-mp="1muyx9l8ih2yj" />
                  </span>
                  <span className="text-sm leading-relaxed text-slate/80" data-id="element-156" data-mp="1cz5kq1usl9gr">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}